import mixpanel from "mixpanel-browser";
import { observer } from "mobx-react";
import { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import useStores from "../../hooks/useStores";
import Button from "../Button";
import FileExtension from "../FileExtension";

type Props = {
  onSelect: (asset: any) => void;
  onClose: () => void;
};

function PreviouslyUsedAttachments({ onSelect }: Props) {
  const { assets } = useStores();

  useEffect(() => {
    assets.fetchTotalCount();
    assets.fetchAttachments();
  }, []);

  const handleDelete = async (asset: any) => {
    await assets.deleteAttachment(asset.id);
    assets.updateTotalCount(assets.data.size);
  };

  const fetchMoreData = async () => {
    console.log("Fetching more data");
    const hasMoreData = await assets.fetchAttachments();
    if (!hasMoreData) {
      assets.updateTotalCount(assets.data.size);
    }
  };

  const handleSelect = (asset: any) => {
    mixpanel.track("new-file-upload-chat", {
      assetId: asset.id,
      uploadType: "PREVIOUSLY_USED",
      processingOptions: {},
    });
    onSelect(asset);
  };

  return (
    <div className="flex flex-col">
      <div className="text-gray-700 mb-4 text-xl font-medium">
        Previously Used Attachments
      </div>

      <div className="max-h-[400px] overflow-hidden">
        <div
          id="scrollableDiv"
          className="custom-scrollbar h-full max-h-[400px] overflow-y-auto"
        >
          <InfiniteScroll
            dataLength={assets.data.size}
            next={fetchMoreData}
            hasMore={assets.data.size < (assets.totalCount || 0)}
            loader={
              <div className="flex w-full justify-center py-2">
                <div className="h-5 w-5 animate-spin rounded-full border-b-2 border-blue-600" />
              </div>
            }
            scrollableTarget="scrollableDiv"
          >
            <table className="w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="text-left text-sm font-medium text-gray-700">
                    Name
                  </th>
                  <th className="text-right text-sm font-medium text-gray-700"></th>
                </tr>
              </thead>
              <tbody>
                {Array.from(assets.data.values()).map((asset) => (
                  <tr
                    key={asset.id}
                    className="border-b border-gray-500 hover:bg-gray-100 flex items-center justify-between py-1.5 pr-2"
                  >
                    <td className="text-sm text-gray-700 flex items-center gap-2">
                      <FileExtension title={asset.name} />
                      {asset.name}
                    </td>

                    <td className="text-right flex items-center gap-2">
                      <Button
                        onClick={() => handleSelect(asset)}
                        theme="primary"
                        type="button"
                        buttonText="Select"
                        
                      />
                      <Button
                        onClick={() => handleDelete(asset)}
                        icon={"trash"}
                        theme="destructive"
                        type="button"
                        
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
}

export default observer(PreviouslyUsedAttachments);
